import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/css/maps/vertical-layout-light/style.css.map";
import "./assets/css/vertical-layout-light/style.css";
// import '/assets/vendors/feather/feather.css'
import "./assets/vendors/mdi/css/materialdesignicons.min.css";
import "./assets/vendors/ti-icons/css/themify-icons.css";
import "./assets/vendors/typicons/typicons.css";
import "./assets/vendors/simple-line-icons/css/simple-line-icons.css";
import "./assets/vendors/css/vendor.bundle.base.css";

// import './assets/js/'
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
